import React, { useCallback } from 'react';
import { useAppDialog } from 'shared/context/AppDialogContext';
import { ACTION_BTN } from 'shared/styles/topBarActions';
import { usePermissions, PERMISSIONS } from 'shared/hooks/usePermissions';

/** Delete behind the app's confirm dialog; resolves true when it went through. */
export function useConfirmDelete() {
  const { confirm } = useAppDialog();
  return useCallback(
    (alert) => confirm(alert.count > 1 ? `${alert.count} alerts will be removed.` : `"${alert.name}" will be removed.`, { title: alert.count > 1 ? 'Delete alerts' : 'Delete alert', confirmLabel: 'Delete', danger: true }),
    [confirm],
  );
}

/** The alert's controls for the top bar: Edit, Delete, and Pause or Start. All neutral. */
export default function AlertActions({ alert, onEdit, onToggle, onDelete }) {
  const canWrite = usePermissions().can(PERMISSIONS.APP_USE);
  if (!canWrite) return null;
  return (
    <div className="flex items-center gap-2">
      <button type="button" onClick={onEdit} className={ACTION_BTN}>Edit</button>
      <button type="button" onClick={onDelete} className={`${ACTION_BTN} hover:text-danger`}>Delete</button>
      <button type="button" onClick={onToggle} className={ACTION_BTN}>{alert.enabled ? 'Pause' : 'Start'}</button>
    </div>
  );
}
